// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_2Dps0","vertical":"_19ysg","bullet":"_2yYN5"};